import axios from "axios";


export default {

    data: () => ({

        // search
        name_search: '',
        code_search: '',

        select: { state: 'Florida', abbr: 'FL' },
        items: [
            { state: 'Florida', abbr: 'FL' },
            { state: 'Georgia', abbr: 'GA' },
            { state: 'Nebraska', abbr: 'NE' },
            { state: 'California', abbr: 'CA' },
            { state: 'New York', abbr: 'NY' },
        ],

        selected_filter: { title: 'کالاها', value: ['شناسه عمومی وارداتی(کالا)', 'شناسه اختصاصی وارداتی(کالا)', 'شناسه عمومی تولید داخل(کالا)', 'شناسه اختصاصی تولید داخل(کالا)'] },
        filters_type: [
            { title: 'کالاها', value: ['شناسه عمومی وارداتی(کالا)', 'شناسه اختصاصی وارداتی(کالا)', 'شناسه عمومی تولید داخل(کالا)', 'شناسه اختصاصی تولید داخل(کالا)'] },
            { title: 'خدمات', value: ['شناسه عمومی(خدمت)', 'شناسه اختصاصی(خدمت)'] },
            { title: 'شناسه عمومی تولید داخل(کالا)', value: 'شناسه عمومی تولید داخل(کالا)' },
            { title: 'شناسه اختصاصی تولید داخل(کالا)', value: 'شناسه اختصاصی تولید داخل(کالا)' },
            { title: 'شناسه اختصاصی وارداتی(کالا)', value: 'شناسه اختصاصی وارداتی(کالا)' },
            { title: 'شناسه عمومی وارداتی(کالا)', value: 'شناسه عمومی وارداتی(کالا)' },
            { title: 'شناسه عمومی(خدمت)', value: 'شناسه عمومی(خدمت)' },
            { title: 'شناسه اختصاصی(خدمت)', value: 'شناسه اختصاصی(خدمت)' },
        ],

        products: '',
        edited_product: {},
        page: 1,
        pages: 1,

        // edit dialog
        edit_dialog: false,
        add_dialog: false,
        is_special: false,
        isService: '',
        ID: '',
        selected_id: "",
        desc: '',
        vat: '',
        vatc: 0,

        type: '',
        selected_type: { title: 'شناسه عمومی تولید داخل(کالا)', value: 'شناسه عمومی تولید داخل(کالا)' },
        types: [
            { title: 'شناسه عمومی تولید داخل(کالا)', value: 'شناسه عمومی تولید داخل(کالا)' },
            { title: 'شناسه اختصاصی تولید داخل(کالا)', value: 'شناسه اختصاصی تولید داخل(کالا)' },
            { title: 'شناسه اختصاصی وارداتی(کالا)', value: 'شناسه اختصاصی وارداتی(کالا)' },
            { title: 'شناسه عمومی وارداتی(کالا)', value: 'شناسه عمومی وارداتی(کالا)' },
            { title: 'شناسه عمومی(خدمت)', value: 'شناسه عمومی(خدمت)' },
            { title: 'شناسه اختصاصی(خدمت)', value: 'شناسه اختصاصی(خدمت)' },
        ],

    }),

    mounted() {
        this.get_main_products()
    },

    methods: {

        async get_main_products(type) {
            if (type === 'search') {
                this.page = 1
            }
            this.$store.commit('progress_status', true)
            await axios({
                method: "GET",
                url: "/mainproducts",
                headers: {
                    token: sessionStorage.getItem("token") || localStorage.getItem("token")
                },
                params: {
                    company: sessionStorage.getItem("company"),
                    search: this.name_search,
                    ID: this.code_search,
                    type: this.selected_filter.value,
                    page: this.page
                }
            })
                .then((res) => {
                    console.log(res.data);
                    this.products = res.data
                    this.pages = res.data.pages
                })
                .catch((err) => {
                    console.log(err);
                    if (err.message ===
                        "Network Error") {
                        this.$store.commit('snackbar', { color: 'red', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                    }
                    else if (err.response.status === 403) {
                        this.$store.commit('snackbar', { color: 'red', text: 'توکن شما منقضی شده' })
                        sessionStorage.clear()
                        localStorage.clear()
                        router.push({ name: "login" })
                    }
                })
                .finally(() => {
                    this.$store.commit('progress_status', false)
                });
        },

        open_add_dialog() {
            this.add_dialog = true
            this.ID = ''
            this.selected_id = ''
            this.desc = ''
            this.vat = ''
            this.vatc = ''
            this.is_special = false
            this.selected_type = { title: 'شناسه عمومی تولید داخل(کالا)', value: 'شناسه عمومی تولید داخل(کالا)' }
        },

        open_edit_dialog(product) {
            this.edited_product = product
            console.log(product);
            this.edit_dialog = true
            this.ID = product.ID
            this.selected_id = product._id
            this.desc = product.desc
            this.vat = product.vat
            this.vatc = product.vatC
            this.type = product.type
            this.is_special = product.isSpecial
            this.selected_type = { title: product.type, value: product.type }
        },

        replace_edited_data() {
            var foundIndex = this.products.docs.findIndex(p => p.id == this.selected_id);
            this.products.docs[foundIndex] = {
                ID: this.ID,
                desc:this.desc,
                id: this.selected_id,
                isActive: this.edited_product.isActive,
                isFree: this.vat ? false : true,
                isSpecial: this.is_special,
                type: this.type,
                vat: this.vat,
                vatC: this.vatc,
                _id: this.selected_id,
            };

            console.log(this.products.docs);
        },

        async add_product() {

            if (this.desc === "" && this.vat === "") {
                this.$store.commit('snackbar', { color: '#D50000', text: "فیلد شناسه کالا و نام کالا اجباری است" })
            }
            else {
                this.$store.commit('progress_status', true)
                await axios({
                    method: "POST",
                    url: "/mainproduct",
                    headers: {
                        token: sessionStorage.getItem("token") || localStorage.getItem("token")
                    },
                    data: {
                        ID: this.ID,
                        desc: this.desc,
                        vat: this.vat,
                        vatC: this.vatc,
                        type: this.selected_type.value,
                        isSpecial: this.is_special,
                        isFree: this.vat ? false : true
                    }
                })
                    .then((res) => {
                        console.log(res.data);
                        this.$store.commit('snackbar', { color: 'green', text: res.data })
                        this.add_dialog = false
                        // this.get_main_products()
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$store.commit('snackbar', { color: '#D50000', text: err.response.data })
                        if (err.message ===
                            "Network Error") {
                            this.$store.commit('snackbar', { color: '#D50000', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                        }
                        else if (err.response.status === 403) {
                            this.$store.commit('snackbar', { color: '#D50000', text: 'توکن شما منقضی شده' })
                            sessionStorage.clear()
                            localStorage.clear()
                            router.push({ name: "login" })
                        }

                    })
                    .finally(() => {
                        this.$store.commit('progress_status', false)
                    });
            }

        },

        async edit_product() {

            if (this.desc === "" && this.vat === "") {
                this.$store.commit('snackbar', { color: '#D50000', text: "فیلد شناسه کالا و نام کالا اجباری است" })
            }
            else {
                this.$store.commit('progress_status', true)
                await axios({
                    method: "PUT",
                    url: "/mainproduct",
                    headers: {
                        token: sessionStorage.getItem("token") || localStorage.getItem("token")
                    },
                    params: {
                        id: this.selected_id,
                    },
                    data: {
                        desc: this.desc,
                        vat: this.vat,
                        vatC: this.vatc,
                        type: this.selected_type.value,
                        isSpecial: this.is_special,
                        isFree: this.vat ? false : true
                    }
                })
                    .then((res) => {
                        console.log(res.data);
                        this.$store.commit('snackbar', { color: 'green', text: res.data })
                        this.edit_dialog = false
                        // this.get_main_products()
                        this.replace_edited_data()
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$store.commit('snackbar', { color: '#D50000', text: err.response.data })
                        if (err.message ===
                            "Network Error") {
                            this.$store.commit('snackbar', { color: '#D50000', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                        }
                        else if (err.response.status === 403) {
                            this.$store.commit('snackbar', { color: '#D50000', text: 'توکن شما منقضی شده' })
                            sessionStorage.clear()
                            localStorage.clear()
                            router.push({ name: "login" })
                        }

                    })
                    .finally(() => {
                        this.$store.commit('progress_status', false)
                    });
            }

        },

        async change_activity(data) {
            this.$store.commit('progress_status', true)

            await axios({
                method: "PATCH",
                url: "/mainproduct",
                headers: {
                    token: sessionStorage.getItem("token") || localStorage.getItem("token")
                },
                params: {
                    id: data.id,
                },
                data: {
                    isActive: !data.isActive
                }
            })
                .then((res) => {
                    console.log(res.data);
                    this.$store.commit('snackbar', { color: 'green', text: res.data })
                })
                .catch((err) => {
                    console.log(err);
                    this.$store.commit('snackbar', { color: '#D50000', text: err.response.data })
                    if (err.message ===
                        "Network Error") {
                        this.$store.commit('snackbar', { color: '#D50000', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                    }
                    else if (err.response.status === 403) {
                        this.$store.commit('snackbar', { color: '#D50000', text: 'توکن شما منقضی شده' })
                        sessionStorage.clear()
                        localStorage.clear()
                        router.push({ name: "login" })
                    }
                })
                .finally(() => {
                    this.$store.commit('progress_status', false)
                });
        },



    }

}